export default __webpack_public_path__ + "static/media/icon-oven.09a83b43.svg";